import moment from 'moment-mini'
import DateView from '../views/DateView'
import pickerDateMixin from './picker-date-mixin'
import { PickerType } from '../constants'

export default {
  name: 'KDatePickerDate',
  mixins: [pickerDateMixin],
  provide() {
    return {
      picker: this,
    }
  },
  props: {},
  data() {
    return {
      pickerType: PickerType.Date,
      referenceValue: moment(),
    }
  },
  computed: {
    year() {
      return this.referenceValue && this.referenceValue.year()
    },
    month() {
      return this.referenceValue && this.referenceValue.month()
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.referenceValue = value || this.defaultReferenceValue || moment()
      },
    },
    active: {
      immediate: true,
      handler(value) {
        if (value) {
          this.referenceValue = this.value || this.defaultReferenceValue || moment()
        }
      },
    },
  },
  created() {
    this.$on('click-prev', (referenceValueKey) => {
      this[referenceValueKey] = this[referenceValueKey].clone().subtract(1, 'month')
    })

    this.$on('click-next', (referenceValueKey) => {
      this[referenceValueKey] = this[referenceValueKey].clone().add(1, 'month')
    })
  },
  methods: {
    handleCellClick(cell) {
      this.$emit('pick', cell.value)
    },
  },
  render() {
    const css = {
      'km-date-picker__pane': true,
    }

    const data = {
      class: css,
    }

    return (
      <div class="km-date-picker__pane-wrapper">
        {this.renderShortcuts()}
        <div {...data}>
          {this.renderHeader(this.referenceValue, 'referenceValue')}
          <DateView
            referenceValue={this.referenceValue}
          />
        </div>
      </div>
    )
  },
}
